<template>
  <div class="local-area">
    <MglMap
      :accessToken="map.token"
      :mapStyle="map.style"
      :center="map.center"
      :zoom="map.zoom"
    >
      <MglMarker
        v-for="marker in markers"
        :key="marker.key"
        :coordinates="marker.coordinates"
        :offset="marker.offset ? marker.offset : [0, 0]"
      >
        <img :src="marker.icon" alt="" slot="marker" />
        <MglPopup v-if="marker.hasPopup" anchor="bottom" :offset="[0, -18]">
          <Popup :popup="marker.popup" />
        </MglPopup>
      </MglMarker>
      <!-- <MglGeojsonLayer
        v-for="shape in shapes"
        :key="shape.data.id"
        :sourceId="shape.data.id"
        :source="shape"
        :layerId="shape.data.id"
        :layer="geoJsonlayer"
      /> -->
    </MglMap>
  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import { MglMap, MglMarker, MglPopup } from "vue-mapbox";
// , MglGeojsonLayer
import Popup from "@/components/local-area/Popup.vue";

import markers from "@/data/local-area/markers";
// import shapes from "@/data/local-area/shapes";

export default {
  name: "LocalArea",
  components: {
    MglMap,
    MglMarker,
    MglPopup,
    Popup
  },
  data() {
    return {
      map: {
        token:
          "pk.eyJ1IjoiYXZlcnllbGxlciIsImEiOiJjamx3bGtwcHUwMHdnM3dtY2h6bTNuZmd2In0.xdACIps6VbrcL6f4VGNrhA",
        style: "mapbox://styles/averyeller/ck2wjczfm09pn1cnzd9le2kmb",
        center: [-117.1677154, 32.7160044],
        zoom: 15.9
      },
      markers
    };
  },
  created() {
    this.mapbox = Mapbox;
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.local-area {
  border: 1.5rem solid $gold;
  height: 100%;
}

.mapboxgl-marker {
  cursor: pointer;
}

@media screen and (max-width: 812px) {
  .local-area {
    border: none;
  }
}
</style>
